import React from "react";
import { Box, Typography, Stack } from "@mui/material";
// import RocketryButton from "../components/RocketryButton";
import Footer from "../sections/Footer";
// import {Events} from "../sections/Events";
import Header from "../Header";
import projects from "../data/projects";
import {useParams} from "react-router-dom";


function ProjectPage() {


    const { projectId } = useParams();   // ← or "project", see next step
    const data = projects[projectId];
    if (!data) return <h2>Page not found</h2>;
    return (
        <Box
            sx={{
                minHeight: "100vh",
                display: "flex",
                flexDirection: "column",

            }}
        >
            <title>{data.title}</title>
            <Header />
            <Stack

                direction="column"
                spacing={5}
                sx={{
                    scrollSnapAlign: "start",
                    backgroundColor: "#A8ACB0",
                    flexGrow: 1,
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    textAlign: "center",
                }}
            >

                <Box>
                    <Typography variant={"h4"} sx={{mb: 2}} color={""}>
                        {data.title}
                    </Typography>

                    <Typography variant={"body1"} sx={{mb: 2,p:2}} align={"justify"}>
                        {data.description}
                    </Typography>


                </Box>


            </Stack>

            <Footer />

        </Box>
    );
}

export default ProjectPage;